import type { StorageLocation } from '../types/inventory'
import { getApiUrl } from '@/lib/utils'

const API_URL = getApiUrl()

function getFetchOptions(method: string, body?: unknown): RequestInit {
  const options: RequestInit = {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return options
}

async function handleResponse<T>(response: Response): Promise<T> {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error((data as { error?: string }).error ?? `Request failed: ${response.status}`)
  }
  return data as T
}

/**
 * Get all storage locations.
 */
export async function getStorageLocations(): Promise<StorageLocation[]> {
  const response = await fetch(`${API_URL}/api/inventory/storage-locations`, getFetchOptions('GET'))
  const locations = await handleResponse<StorageLocation[]>(response)
  return locations.map((loc) => ({
    ...loc,
    createdAt: new Date(loc.createdAt),
    updatedAt: new Date(loc.updatedAt),
  }))
}

export type CreateStorageLocationInput = {
  name: string
  description?: string
}

/**
 * Create a new storage location.
 */
export async function createStorageLocation(input: CreateStorageLocationInput): Promise<StorageLocation> {
  const response = await fetch(`${API_URL}/api/inventory/storage-locations`, getFetchOptions('POST', input))
  const location = await handleResponse<StorageLocation>(response)
  return {
    ...location,
    createdAt: new Date(location.createdAt),
    updatedAt: new Date(location.updatedAt),
  }
}
